// How a desk page knows it has been asked for, and that another ask is in flight.
//
// Hooked on `authenticated` rather than on `ask`. Login is not a page read, and
// lighting the dots because somebody typed an email would be the wrong clock.

let inflight = 0;
let checkedAt: number | null = null;
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) listener();
}

export function subscribeFreshness(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function freshnessSnapshot(): { readonly inflight: number; readonly checkedAt: number | null } {
  return { inflight, checkedAt };
}

export function beginRead(): void {
  inflight += 1;
  emit();
}

export function endRead(): void {
  inflight = Math.max(0, inflight - 1);
  if (inflight === 0) checkedAt = Date.now();
  emit();
}
